import LocalizedStrings from "react-localization";
import { localization } from "../../localization";
import { useLanguageContext } from "../contexts/LanguageContext";
import { useMemo } from "react";

export default function useTranslation() {
  const { language } = useLanguageContext();

  return useMemo(() => {
    const translation = new LocalizedStrings(localization);
    translation.setLanguage(language || "en");
    return translation;
  }, [language]);
}
